module.exports = "/img/_/_/_/assets/images/creeper/book/common//6.jpg?040930b0bfaa2746d52c2360faeaaeac";